import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Image } from '@/components/common/image';
import { useMediaQuery } from '@/lib/useMediaQuery';

import type { StyledImageProps } from '@/types/shared';

export const StyledImage = (image: StyledImageProps) => {
  const isDesktop = useMediaQuery(screen.smQuery);
  const displayImage = isDesktop ? image.desktopImage : image.mobileImage;
  return (
    <ImageContainer>
      <Image
        {...displayImage}
        alt={image.alternateText}
        radius="component-xl"
        objectFit="cover"
      />
    </ImageContainer>
  );
};

const ImageContainer = styled.div`
  padding-top: var(--space-block-lg);
  margin-left: -8px;
  margin-right: -8px;

  > img {
    max-height: 320px;
  }

  ${screen.md} {
    margin-left: -20px;
    margin-right: -20px;
  }

  ${screen.lg} {
    margin-left: calc(var(--space-block-md) * -1);
    margin-right: calc(var(--space-block-md) * -1);

    > img {
      max-height: 340px;
    }
  }
`;
